module.exports = __webpack_public_path__ + "static/media/description.cb6c51c9.svg";